module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/6-613de5feea099954255483c39cd7b5a8.png";